import { VesselSpec } from './vessel-spec';

export interface VesselSpecStoreState {
  readonly vesselSpec: VesselSpec | undefined;
  readonly isFetchingVesselSpec: boolean;
  readonly fetchError: string | undefined;
  readonly isUpdatingVesselSpec: boolean;
  readonly updateError: string | undefined;
}

export const INITIAL_VESSEL_SPEC_STORE_STATE: VesselSpecStoreState = {
  vesselSpec: undefined,
  isFetchingVesselSpec: false,
  fetchError: undefined,
  isUpdatingVesselSpec: false,
  updateError: undefined,
};
